import { request } from '@h3/request';
import { H3 } from '@h3/types';

// 获取导入导出字段模板
export const getDataPortColumns = (
    schemaCode: string,
    type: H3.DataPort.DataPortType,
    importDataType: H3.Import.ImportDataStatus = H3.Import.ImportDataStatus.Draft,
) => {
    const url = `/v2/dataPort/getExportColumns?SchemaCode=${schemaCode}&dataPortType=${type}&importDataType=${importDataType}`;
    return request<H3.Http.Response.H3Response<H3.Export.Response.IExportProperty[]>>(url, {
        method: 'get',
        params: {},
    });
};

// 获取导入导出历史记录
export const getDataPortTaskRecords = (
    type: H3.DataPort.DataPortType,
    schemaCode: string,
    taskIds: string[],
    recentHours = 72,
) => {
    const url = '/v1/dataPort/LoadTaskRecords';
    return request<H3.Http.Response.H3Response<H3.DataPort.Response.IDataPortTaskRecordResponse>>(url, {
        data: {
            Type: type,
            TaskIds: taskIds,
            RecentHours: recentHours,
            SchemaCode: schemaCode,
        },
        method: H3.Http.MethodType.POST,
    });
};

// 取消等待中的导入导出任务
export const cancelWaitingTask = (taskId: string, type: H3.DataPort.DataPortType) =>
    request<H3.Http.Response.H3Response<boolean>>(`/v1/dataPort/CancelWaitingTask/${taskId}/${type}`, {
        method: 'get',
    });

// 超时任务重试
export function retryTasks(taskIds: string[]) {
    return request<H3.Http.Response.H3Response<boolean>>('/v1/dataPort/RetryTimeoutTasks', {
        method: H3.Http.MethodType.POST,
        data: taskIds,
    });
}
